<template>
  <div class="prize-detail-modal-2020__content">
    <img
      :src="require(`@/assets/img/prizes/skins/big/${prize.imgBig}`)"
      :alt="prize.title"
      class="prize-detail-modal-2020__img"
    />
    <div class="prize-detail-modal-2020__title" v-text="prize.title" />
    <div class="prize-detail-modal-2020__subtitle">
      Используется: {{ prize.hero }}
    </div>
    <div class="prize-detail-modal-2020__text" v-html="prize.descr" />
  </div>
</template>

<script>
export default {
  name: "PrizeDetailModal2020",
  props: {
    prize: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.prize-detail-modal-2020 {
  %font-base {
    font-family: "Open Sans";
    font-style: normal;
  }

  %text {
    @extend %font-base;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;
  }

  %title {
    @extend %font-base;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
  }

  %subtitle {
    @extend %font-base;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #fbc33e;
  }

  .modal-card {
    padding: 40px 30px;

    @include breakpoint("xs-only") {
      padding: 30px 20px;
    }
    // @include breakpoint('xs-only')
  }

  &__content {
    max-width: 360px;
  }

  &__img {
    width: 100%;
    max-width: 360px;
  }

  &__text {
    @extend %text;
    margin-top: 20px;

    span {
      color: #fbc33e;
    }
  }

  &__title {
    @extend %title;
    margin-top: 20px;
  }

  &__subtitle {
    @extend %subtitle;
  }
}
</style>
